import styled from "styled-components";
import { Color, Font, breakpoints, ColorDark } from "@/shared/Constants";

export const AstrologyButton = styled.li`
  .astrology-today {
    ${Font.sansRegular};
    background-color: ${Color.greyF5F5F5};
    border-radius: 50px;
    border: none;
    color: ${Color.black000};
    cursor: pointer;
    font-size: 13px;
    margin: 5px;
    padding: 13px 15px;
    text-align: center;
    text-decoration: none;
    ${breakpoints.darkMode} {
      [data-theme='dark'] & {
      background-color: ${ColorDark.greySeparator};
      color: ${ColorDark.textLight};
      }
    }
    &:hover {
      background-color: ${Color.mainColor};
      color: ${Color.white};
      ${breakpoints.darkMode} {
        [data-theme='dark'] & {
        background-color: ${ColorDark.mainColor};
        }
      }
    }
    ${breakpoints.tablet} {
      margin-bottom: 0px;
    }
    ${breakpoints.phone} {
      margin-bottom: 30px;
    }
  }
  .how-is {
    background-color: ${Color.yellow2};
    color: ${Color.black000};
    width: fit-content;
    &:hover {
      background-color: ${Color.yellow2};
      color: ${Color.black000};
      ${breakpoints.darkMode} {
        [data-theme='dark'] & {
        background-color: ${ColorDark.yellow2};
        }
      }
    }
  }
  &.how-is-li {
    width: 100%;
    display: flex;
    justify-content: center;
    ${breakpoints.phone} {
      display: none;
    }
  }
  .how-is-mobile {
    ${breakpoints.phone} {
      background-color: yellow;
      width: fit-content;
    }
    ${breakpoints.darkMode} {
      [data-theme='dark'] & {
      color: ${Color.black000};
      }
    }
  }
  &.how-is-li-mobile {
    display: none;
    ${breakpoints.phone} {
      width: 100%;
      display: flex;
      justify-content: center;
    }
  }
`;
